import React from "react";
import "./About.css";

const About = () => (
  <section className="about" id="about">
    <h2>KATAR KENTSEL YAPI VE İNŞAAT TİC. LTD. ŞTİ.</h2>



    <p><strong>F Grubu Müteahhitlik Karnesi </strong> </p>
    <p>
  <strong>Hızlı, eksiksiz ve kalite odaklı projeler.</strong> Şehir ölçeğinden iç mekâna kadar her projede pratik ve uygulanabilir çözümler geliştiriyoruz.
</p>

<p>
  <strong>Tüm süreçleri tek çatı altında yönetiyoruz.</strong> Disiplinler arası deneyimimizle zamanında ve güvenli teslimat sağlıyoruz.
</p>

<p>
  <strong>Şeffaf ve ölçülebilir ilerliyoruz.</strong> Tasarımdan uygulamaya kadar tüm aşamalarda net iletişim kuruyoruz.
</p>

    <a href="#contact" className="btn about-cta">
      İLETİŞİME GEÇİN
    </a>
  </section>
);

export default About;